/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';

/**
 * 
 * @export
 * @interface Player
 */
export interface Player {
    /**
     * 
     * @type {string}
     * @memberof Player
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof Player
     */
    playerNumber?: number;
    /**
     * 
     * @type {Person}
     * @memberof Player
     */
    person?: Person;
}

/**
 * Check if a given object implements the Player interface.
 */
export function instanceOfPlayer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PlayerFromJSON(json: any): Player {
    return PlayerFromJSONTyped(json, false);
}

export function PlayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Player {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'person': !exists(json, 'person') ? undefined : PersonFromJSON(json['person']),
    };
}

export function PlayerToJSON(value?: Player | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'playerNumber': value.playerNumber,
        'person': PersonToJSON(value.person),
    };
}

